<template>
  <div>
    <div class="dashboard__topbar">
      <KeywordFilter></KeywordFilter>
    </div>

    <div class="dashboard__widgets widget-container">

        <list-widget class="widget-container__widget"
            routeName="user"
            :items="users.items"
            :totalCount="users.total" v-if="hasPermitPacks()">
          <template slot="header">{{ $t('dashboard.users') }}</template>
          <template slot="add-button">
            <router-link :to="{name: 'add-user'}" class="link link--blue">{{ $t('users.add_user') }}
              <i class="icon icon--plus"></i>
            </router-link>
          </template>
          <template slot="item-template" slot-scope="props">
            <UserItemTemplate :item="props.item" />
          </template>
          <template slot="footer">
            <router-link :to="{ name: 'users'}">{{ $t('common.show_all') }}</router-link>
          </template>
        </list-widget>

        <!-- <AddGuestForm></AddGuestForm> -->

      <!--
      <list-widget class="widget-container__widget"
          routeName="permit"
          :items="permits.items"
          :totalCount="permits.total" v-if="hasPermitPacks()">
        <template slot="header">{{ $t('dashboard.permits') }}</template>
        <template slot="add-button">
          <router-link :to="{name: 'add-permit'}" class="link link--blue">{{ $t('permits.add_permit') }}
            <i class="icon icon--plus"></i>
          </router-link>
        </template>
        <template slot="item-template" slot-scope="props">
          <PermitItemTemplate :item="props.item" />
        </template>
        <template slot="footer">
          <router-link :to="{ name: 'permits'}">{{ $t('common.show_all') }}</router-link>
        </template>
      </list-widget>
      -->

      <list-widget
        v-if="hasGuestParking() && false"
        class="widget-container__widget"
        routeName="parkings"
        :items="parkings.items"
        :totalCount="parkings.total"
        >
        <template slot="header">{{ $t('dashboard.parkings') }}</template>
        <template slot="add-button">
          <router-link :to="{name: 'add-parking'}" class="link link--blue">{{ $t('parking.add_parking') }}
            <i class="icon icon--plus"></i>
          </router-link>
          <a href="#" @click.prevent="showListModal = true" class="link link--blue">{{ $t('common.show_all') }}
            <i class="icon icon--arrow"></i>
          </a>
        </template>
        <template slot="item-template" slot-scope="props">
          <ParkingsItemTemplate :item="props.item" />
        </template>
        <!-- <template slot="footer">
          <router-link :to="{ name: 'parkings'}">{{ $t('common.show_all') }}</router-link>
        </template> -->
      </list-widget>
    </div>
    <ListModal
      @cancel="closeListModal"
      @confirmed="confirmedListModal"
      v-if="showListModal"
      :isShowFooterButtons="false"
    >
      <template v-slot:default>
        <list-widget
          routeName="parkings"
          :items="parkings.items"
          :totalCount="parkings.total"
          v-if="hasGuestParking()"
          :hideHeader="true"
          :hideFooter="true"
        >
          <template slot="item-template" slot-scope="props">
            <ParkingsItemTemplate :item="props.item" />
          </template>
        </list-widget>
      </template>
    </ListModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import 'pusher-js';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';
import ListModal from 'common/ListModal';
import Autocomplete from 'common/Autocomplete';
import PermitItemTemplate from 'permits/ListItemTemplate';
import UserItemTemplate from 'users/ListItemTemplate';
import ParkingsItemTemplate from 'parkings/ListItemTemplate';
import KeywordFilter from './KeywordFilter';
import { connectEcho } from 'src/utils.js'

export default {
  components: {
    ListWidget,
    ListModal,
    Autocomplete,
    ParkingsItemTemplate,
    PermitItemTemplate,
    UserItemTemplate,
    KeywordFilter,
  },
  computed: mapGetters({
    users: 'landlord/users/users',
    permits: 'landlord/permits/permits',
    parkings: 'landlord/parkings/parkings',
    user: 'user/user/user',
  }),
  created() {
    if (this.hasPermitPacks()) {
      this.fetchUsers();
      this.fetchPermits();
    }
    if (this.hasGuestParking()) {
      this.fetchParkings();
    }
  },
  mounted() {
    // this.user.data.selectedRole.isSuperadmin && this.user.data.selectedRole.isSuperadmin === true ? this.role = 'superAdmin' : this.role = `${this.user.data.selectedRole.role}s`;
    this.role = `${this.user.data.selectedRole.role}s`;
    this.roleId = this.user.data.selectedRole.id;
  },
  methods: {
    fetchUsers() {
      this.$store.dispatch('landlord/users/fetch', { user: this.user, limit: this.limit, orderBy: 'updated_at' });
    },
    fetchPermits() {
      this.$store.dispatch('landlord/permits/fetch', { user: this.user, limit: this.limit });
    },
    fetchParkings() {
      this.$store.dispatch('landlord/parkings/fetch', { user: this.user, limit: this.limit })
        .then(() => {
          this.initProductsWebsocets();
        });;
    },
    initProductsWebsocets() {
      connectEcho().private(`user_${this.role}_${this.roleId}`)
        .listen('.change.guest.pack.count', (e) => {
          console.log(e);
        });
    },
    closeListModal() {
      this.showListModal = false;
    },
    confirmedListModal() {
      this.showListModal = false;
    },
  },
  data() {
    return {
      limit: 10,
      role: null,
      roleId: null,
      showListModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/app.scss';
  .dashboard {
    &__content {
      margin-top: 0;
    }
    &__mainview {
      background-color: inherit;
      background-color: inherit;
      padding: 0;
    }
  }

  .widget-container {
    margin: 20px 0 0 0;
    display: flex;
    flex: 1;
    align-content: stretch;
    justify-content: flex-start;
    transition: all 250ms ease-in-out;

    @media screen and (max-width: 700px) {
      flex-direction: column;
      transition: all 250ms ease-in-out;
    }

    @media screen and (max-width: 1115px) {
      flex-direction: column;
      transition: all 250ms ease-in-out;
    }

    &__widget {
      margin: 0 10px 10px 0;
      width: 300px;
      max-width: 600px;
      flex: 1 0 auto;
      transition: all 250ms ease-in-out;

      @media screen and (max-width: 1115px) {
        width: auto;
        transition: all 250ms ease-in-out;
        margin: 0 0 10px 0;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tenant-dashboard/MainView.vue